export * from './customer-add-edit';
export * from './customer-save-offer';
export * from './customer-ticket';
export * from './customer-ticket-view-page';
export * from './patrol-history/patrol-history.component';
export * from './relocation';
export * from './subscription-cancel';
export * from './support-document';
export * from './process-cancellation';
export * from './suspension-service';
export * from './balance-of-contract';
export * from './purchase-of-alarm-system';
